import React, { useEffect, useState } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import InputComponent from "../InputComponent";
import { serviceUpdateUser } from "../../../patient/services/patientRegistrationRequesApi";
import { showToast } from "../../../patient/utils/toastUtils";
import { getValueFromPatToken } from "../../../patient/utils/commonUtils";
import { serviceFetchUserBasicInfo } from "../../services/profileApi";
import { getValueFromToken } from "../../utils/tokenUtils";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import AntDatePicker from "../antDatepicker";
import dayjs from "dayjs";

const BasicInfoSection = ({
  collapsed,
  toggleSection,
  callType
}) => {

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("");
  const [loginUserId, setLoginUserId] = useState(null);

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Other", label: "Other" },
  ];

    // basicInfo - Name, DOB, Gender
    const updateBasicInfo = async () => {
      const response = await serviceUpdateUser({
        userId: loginUserId,
        firstName: firstName === "" ? null : firstName,
        lastName: lastName === "" ? null : lastName,
        dateOfBirth: birthDate === "" ? null : birthDate,
        gender: gender === "" ? null : gender,
        callType:callType
      });
    
      if(response?.status){
        showToast(response?.message,"success")
      }else{
        showToast(response?.message,"error")
      }
    };

    const fetchUserBasicInfo = async (id) => { 
      const response = await serviceFetchUserBasicInfo(id);
      if (response?.status) { 
        const { basicInfo } = response?.data;
        setFirstName(basicInfo.first_name);
        setLastName(basicInfo.last_name);
        setBirthDate(basicInfo.date_of_birth);
        setGender(basicInfo.gender);
      }    
    };
   
    useEffect( () => {
      let temp;
      if(callType === 'patient'){
        temp = getValueFromPatToken("user_id");
      }else{        
        temp = getValueFromToken("user_id");
      }
      setLoginUserId(temp) 
    }, []);

    useEffect(() => {
      if(loginUserId) 
      {
        fetchUserBasicInfo(loginUserId);
      }
    }, [loginUserId]);

  return (
    <div className="section">
      <div className="section-header flex justify-between items-center pb-3 border-b border-gray-200 text-gray-900 text-lg pt-3 font-medium px-5">
        <div className="text-left">Basic Information</div>
        <button onClick={() => toggleSection("basicInfo")}>
          {collapsed ? <FiPlus /> : <FiMinus />}
        </button>
      </div>
      {!collapsed && (
        <div className="section-content px-5 py-12 border-b border-gray-200">
          <div className="flex flex-row flex-wrap -mx-3 gap-y-6">
            <div className="w-full lg:w-1/2 px-3">
              <InputComponent
                label="First Name"
                id="name"
                value={firstName}
                type="text"
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="w-full lg:w-1/2 px-3">
              <InputComponent
                inputClassName="w-full"
                label="Last Name"
                id="name"
                value={lastName}
                type="text"
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
            <div className="w-full lg:w-1/2 px-3">
              <label className="mb-1 text-gray-800 bg-white font-semibold text-[14px] block text-left">
                Date of birth
              </label>
              <AntDatePicker
                defaultValue={null}
                placeholder="select date"
                value={birthDate? dayjs(birthDate):null}
                onChange={(date,dateString) => setBirthDate(dateString)}
                disabledFutureDate={true}
              />
            </div>
            <div className="w-full lg:w-1/2 px-3">
              <label
                htmlFor="gender_new"
                className="mb-1 text-gray-800 bg-white font-semibold text-[14px] block text-left"
              >
                Gender
              </label>

              <div className=" relative form_select">
                <Select
                  id="gender"
                  isSearchable={false}
                  isClearable={false}
                  isDisabled={false}
                  placeholder="Select gender"
                  classNamePrefix="custom-select"
                  className="custom-select-container"
                  controlClassName="custom-select-control"
                  menuClassName="custom-select-menu"
                  optionClassName="custom-select-option"
                  singleValueClassName="custom-select-single-value"
                  value={genderOptions.find(
                    (option) => option.value === gender
                  )}
                  onChange={(selectedOption) => setGender(selectedOption.value)}
                  options={genderOptions}
                />
              </div>
            </div>
          </div>
          <button
            className="min-w-[131px] text-base font-medium rounded-lg py-2 px-5 bg-[#2E37A4] text-white mt-6"
            onClick={updateBasicInfo}
          >
            Update
          </button>
        </div>
      )}
    </div>
  );
};

export default BasicInfoSection;
